import { ReactNode } from 'react';
import cx from 'classnames';
import {
  Provider,
  Root,
  Trigger,
  Portal,
  Content,
} from '@radix-ui/react-tooltip';
import s from './styles.scss';

export interface TooltipProps {
  tip: ReactNode;
  children: ReactNode;
  className?: string;
  onOpenChange?: (open: boolean) => void;
}

export const Tooltip = ({
  tip,
  children,
  className,
  onOpenChange = () => {},
}: TooltipProps): JSX.Element => {
  if (!tip) {
    return <>{children}</>;
  }

  return (
    <Provider>
      <Root onOpenChange={onOpenChange}>
        <Trigger asChild className={cx(s.trigger, className)}>
          <span>{children}</span>
        </Trigger>
        <Portal>
          <Content className={cx(s.tip, className)}>{tip}</Content>
        </Portal>
      </Root>
    </Provider>
  );
};
